import gql from 'graphql-tag';

export const getControllerNotes = gql`
  query getControllerNotes(
    $StartDate: String
    $EndDate: String
    $AOR: [String]
    $IsHistorical: Boolean
    $TurnoverOnly: Boolean
    $businessUnits: [String]
    $hideMaintenance: Boolean
  ) {
    getControllerNotes(
      startDate: $StartDate
      endDate: $EndDate
      aor: $AOR
      isHistorical: $IsHistorical
      turnoverOnly: $TurnoverOnly
      businessUnits: $businessUnits
      hideMaintenance: $hideMaintenance
    ) {
      category
      AORId
      AORName
      addToTurnover
      abnormalOperation
      businessUnits
      city
      contactId
      contactName
      createdAt
      county
      createdBy
      facilityName
      facilityId
      facilityUID
      falseAlarm
      id
      maop
      noteType
      phoneNumber
      pipeline
      pipelineSection
      state
      township
      updatedAt
      updater
      systemName
      entries {
        createdAt
        createdBy
        id
        note
        time
        updatedAt
        updater
        version
        controllerNotesId
      }
      calloutInitiated
      unit
      unitStatus {
        id
        name
      }
      maintenance
      facilityScadaId
      valvePosition {
        id
        name
      }
      SCADAControl {
        id
        name
      }
    }
  }
`;
